import script from "./EditorSmilesDropdown.vue?vue&type=script&setup=true&lang=js"
export * from "./EditorSmilesDropdown.vue?vue&type=script&setup=true&lang=js"

import "./EditorSmilesDropdown.vue?vue&type=style&index=0&id=b077a452&lang=scss"

const __exports__ = script;

export default __exports__